module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content"
  }, [_c('ul', {
    staticClass: "list list-activity"
  }, [(_vm.order.return_shipment) ? _c('li', [_c('i', {
    staticClass: "si si-action-undo text-danger"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Retourzending aangemaakt")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.order.return_shipment.track_and_trace_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v("\n          " + _vm._s(_vm.order.return_shipment.barcode) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.order.return_shipment.created_at, 'calendar'))))])]) : _vm._e(), _vm._v(" "), (_vm.order.status === 'completed') ? _c('li', [_c('i', {
    staticClass: "si si-check text-success"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Bestelling afgerond")]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.completedAt, 'calendar'))))]), _vm._v(" "), (_vm.order.weshipp_id) ? _c('div', [(!_vm.solTrackAndTraceUrl) ? _c('button', {
    staticClass: "btn btn-alt-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.getSolTrackAndTraceUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }, [_vm._v(" SOL Track & trace ophalen ")]), _vm._v(" "), (_vm.loading) ? _c('i', {
    staticClass: "fa fa-spin fa-8x fa-spinner"
  }) : _vm._e()]) : _c('a', {
    attrs: {
      "href": _vm.solTrackAndTraceUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v("\n          SOL Track & trace\n        ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.order.shipment) ? _c('li', [_c('i', {
    staticClass: "si si-paper-plane text-warning"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Verzending aangemaakt")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.printLabel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.order.shipment.track_and_trace_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v("\n          " + _vm._s(_vm.order.shipment.barcode) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.order.shipment.created_at, 'calendar'))))])]) : _vm._e(), _vm._v(" "), (_vm.pickedAt) ? _c('li', [_c('i', {
    staticClass: "si si-directions text-info"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Producten gepickt")]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.pickedAt, 'calendar'))))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "si si-basket text-danger"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Bestelling geplaatst")]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.order.placed_at, 'calendar'))))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d59abe2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/orders/OrderTimeline.vue
// module id = 708
// module chunks = 1